import React from 'react'
import Password_managementForm from '../Password_managementForm/Password_managementForm'

const Password_managementPage = () => {
    return (
        <div>
            <Password_managementForm />
        </div>
    )
}

export default Password_managementPage
